import getEnv from 'utils/getEnv'
import type { ConfigOptions } from 'utils/settings'

const {
  VITE_APP_DEFAULT_LANGUAGE: defaultLanguage,
  VITE_APP_LANGUAGES: languages,
} = getEnv()

export default {
  // Default language of the UI if we can't detect their language
  defaultUILanguage: defaultLanguage,
  uiLanguages: languages,

  defaultContentLanguage: defaultLanguage,
  contentLanguages: languages,
} as ConfigOptions
